import './large-view-save-changes-popup.css'
const LargeViewSaveChangesPopup = ({tryToClosePopup, closeBoth, setKeepEditing}) => {
    return (
        <div className='teacher-calendar-event-editing__repeat-event-keep-editing__wrapper' id='teacher-calendar-event-editing__repeat-event-keep-editing__wrapper' onClick={(e) => tryToClosePopup(e.target.id)}>
            <div className='teacher-calendar-event-editing__keep-editing__wrapper' id='teacher-calendar-event-editing__keep-editing__wrapper'>
                <div className='teacher-calendar-event-editing__repeat-event-options'>
                    <div className='teacher-calendar-event-editing__repeat-event-label'>Are you sure you want to discard your changes?</div>
                    <div className='teacher-calendar-event-editing__repeat-event-button' onClick={() => closeBoth()}>Discard Changes</div>
                </div>
                <div className='teacher-calendar-event-editing__repeat-event-cancel' onClick={() => setKeepEditing(false)}>Keep Editing</div>
            </div>
        </div>
    )
}
export default LargeViewSaveChangesPopup